import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService, UrlParam } from "./classes/BaseService";
import { Global } from './classes/Global';
import { MovieRatingsFilters } from './movie-ratings-sliders/movie-ratings-sliders.component';
import { InternationalizationHelper } from './helpers/InternationalizationHelper';

@Injectable()
export class OffersService extends BaseService{

  apiUrl = "OfferList.php?";
  static NEW_ON_PRIME_VIDEO_RELEASE_DATE_SORT = "modInfo-created";

  constructor(protected http: HttpClient) {
    super(http);
  }

  getOffers(store: string, listType: string, country: string, itemType: string,
    genreIds: string, quality: string, sort: string, offset: number, limit: number,
    device: string, priceType: string, advisoryRating, sound,
    moviesAnywhere, hdrFormat, movieRatingsFilters: MovieRatingsFilters,
    studio: string, priceRange: string, audioTrack: string, itunesExtras: string, offersFilter: string,
    releaseYear: string, sortPeriod: string, showBundles: string, runtime: string, hideFrenchTitles: string,
    pricePerMovieRange?: string) {

    sort = this.getOfferListSort(listType, sort);

    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("store", store),
      new UrlParam("listType", listType),
      new UrlParam("country", country),
      new UrlParam("itemType", itemType),
      new UrlParam("genreIds", genreIds),
      new UrlParam("quality", quality),
      new UrlParam("sort", sort),
      new UrlParam("offset", offset.toString()),
      new UrlParam("limit", limit.toString()),
      new UrlParam("releaseYear", releaseYear),
      new UrlParam("offers", offersFilter)
    );

    if(sort == Global.GREATEST_SAVINGS || sort == Global.GREATEST_PERCENTAGE_SAVINGS) {
      url += this.addUrlParam(new UrlParam("sortPeriod", sortPeriod ? sortPeriod : "all"));
    }

    if (itemType == Global.APPS) {
      url += this.addUrlParam(new UrlParam("plattform", device));
    }
    if (itemType == Global.APPS || itemType == Global.MACAPPS) {
      url += this.addUrlParam(new UrlParam("paid", priceType));
    }

    if (priceRange && itemType != Global.APPS && itemType != Global.MACAPPS) {
      url += this.addUrlParam(new UrlParam("priceRange", priceRange));
    }
    else if (priceRange && (itemType == Global.APPS || itemType == Global.MACAPPS) &&
      priceType != Global.PRICE_TYPE_FREE) {
      url += this.addUrlParam(new UrlParam("priceRange", priceRange));
    }

    if (store === Global.ITUNES && listType === Global.BUNDLES && itemType === Global.BUYMOVIES && pricePerMovieRange) {
      url += this.addUrlParam(new UrlParam("pricePerMovie", pricePerMovieRange));
    }

    if ((itemType == Global.BUYMOVIES || itemType == Global.RENTALMOVIES || itemType == Global.SEASONS) &&
      country == Global.countries.us.key && listType != Global.BUNDLES) {
      url += this.addUrlParam(new UrlParam("advisoryRatings", advisoryRating));
    }

    if (itemType == Global.BUYMOVIES || itemType == Global.RENTALMOVIES) {

      if (store == Global.ITUNES) {
        url += this.addUrlParam(new UrlParam("iTunesExtras", itunesExtras));
      }

      if (country == Global.countries.us.key) {
        url += this.addUrlParam(new UrlParam("moviesAnywhere", moviesAnywhere));
      }

      if (store != Global.AMAZON && store != Global.GOOGLEPLAY) {
        url += this.addUrlParam(new UrlParam("soundFormat", sound));
        url += this.addUrlParam(new UrlParam("hdrFormat", hdrFormat));
      }

      if (listType != Global.BUNDLES) {
        url += this.addUrlParam(new UrlParam("studio", studio));
        url += this.addUrlParam(new UrlParam("imdbRange", movieRatingsFilters.imdb.toString()));
        url += this.addUrlParam(new UrlParam("rottenRange", movieRatingsFilters.rotten.toString()));
        url += this.addUrlParam(new UrlParam("letterboxdRange", movieRatingsFilters.letterboxd.toString()));
        url += this.addUrlParam(new UrlParam("metaRange", movieRatingsFilters.metacritic.toString()));
      }

    }

    if(itemType == Global.SEASONS && store == "itunes" &&
      (
        InternationalizationHelper.getTwoCharactersLanguage() == "de" ||
        InternationalizationHelper.getTwoCharactersLanguage() == "at" ||
        InternationalizationHelper.getTwoCharactersLanguage() == "ch"
      )) {
        url += this.addUrlParam(new UrlParam("audioTrack", audioTrack));
    }

    if ((itemType == Global.BUYMOVIES || itemType == Global.RENTALMOVIES || itemType == Global.SEASONS) &&
      (store == Global.ITUNES || store == Global.VUDU) && showBundles && showBundles != 'all') {
      url += this.addUrlParam(new UrlParam("bundleFilter", showBundles));
    }

    if ((itemType == Global.BUYMOVIES || itemType == Global.RENTALMOVIES) && runtime && runtime != '1-350') {
      url += this.addUrlParam(new UrlParam("runtimeRange", runtime));
    }

    if (store == Global.ITUNES && country == Global.countries.ca.key &&
      (itemType == Global.BUYMOVIES || itemType == Global.RENTALMOVIES) && hideFrenchTitles) {
      url += this.addUrlParam(new UrlParam("hideFrenchTitles", hideFrenchTitles));
    }

    return this.get(url);

  }

  getOffersByPerson(actors: string, directors: string, screenwriters: string, store: string, country: string, itemType,
    listType: string, genreIds, sort, offset, limit, releaseYear, priceRange, movieRatingsFilters: MovieRatingsFilters, runtime: string, hideFrenchTitles: string) {

    sort = this.getOfferListSort(listType, sort);

    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("store", store),
      new UrlParam("listType", listType),
      new UrlParam("country", country),
      new UrlParam("itemType", itemType),
      new UrlParam("genreIds", genreIds),
      new UrlParam("sort", sort),
      new UrlParam("offset", offset.toString()),
      new UrlParam("limit", limit.toString()),
      new UrlParam("releaseYear", releaseYear),
      new UrlParam("imdbRange", movieRatingsFilters.imdb.toString()),
      new UrlParam("rottenRange", movieRatingsFilters.rotten.toString()),
      new UrlParam("metaRange", movieRatingsFilters.metacritic.toString()),
      new UrlParam("letterboxdRange", movieRatingsFilters.letterboxd.toString()),
      new UrlParam("quality", store == Global.AMAZON ? "hd" : "hd4k")
    );

    if (priceRange) {
      url += this.addUrlParam(new UrlParam("priceRange", priceRange));
    }

    if(actors) {
      url += this.addUrlParam(new UrlParam("actors", actors));
    }

    if(directors) {
      url += this.addUrlParam(new UrlParam("directors", directors));
    }

    if(screenwriters) {
      url += this.addUrlParam(new UrlParam("screenwriters", screenwriters));
    }

    if ((itemType == Global.BUYMOVIES || itemType == Global.RENTALMOVIES) && runtime && runtime != '1-350') {
      url += this.addUrlParam(new UrlParam("runtimeRange", runtime));
    }

    if (store == Global.ITUNES && country == Global.countries.ca.key &&
      (itemType == Global.BUYMOVIES || itemType == Global.RENTALMOVIES || itemType == Global.MOVIES) && hideFrenchTitles) {
      url += this.addUrlParam(new UrlParam("hideFrenchTitles", hideFrenchTitles));
    }

    return this.get(url);

  }

  private getOfferListSort(listType: string, sort: string): string {
    if (listType == Global.NEW_ON_PRIME_VIDEO && sort == Global.RELEASE_DATE) {
      return OffersService.NEW_ON_PRIME_VIDEO_RELEASE_DATE_SORT;
    }
    return sort;
  }

}
